export const environment = {
  server: {
    url: 'https://api.oktopus.world'
  },
  dsn: 'http://601e68e49c5940208e1a6175a73073f0@glitchtip.oktotech.net/4'
}
